/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Contact_ErrorInputs */

const cs_public_site_contact_error = /** @type {(inputs: Public_Site_Contact_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslání se nepodařilo. Zkuste to prosím znovu.`)
};

const en_public_site_contact_error = /** @type {(inputs: Public_Site_Contact_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send. Please try again.`)
};

/**
* | output |
* | --- |
* | "Could not send. Please try again." |
*
* @param {Public_Site_Contact_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_contact_error = /** @type {((inputs?: Public_Site_Contact_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Contact_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_contact_error(inputs)
	return cs_public_site_contact_error(inputs)
});